export enum ChoiceModes {
  DAYS,
  MONTHS,
  YEARS,
  RANGE,
  KW
}
